import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import "./style.css";

const socialMedia = [
  {
    icon: "fa-pinterest",
    href: "https://www.pinterest.com/flongoflonga/_profile/",
  },
  {
    icon: "fa-tiktok",
    href: "https://www.tiktok.com/@ebdyan",
  },
  {
    icon: "fa-twitter",
    href: "https://twitter.com/onlyabdianhere",
  },
  {
    icon: "fa-linkedin",
    href: "https://linkedin.com/in/gilangabdian",
  },
  {
    icon: "fa-github",
    href: "https://github.com/gilangages",
  },
];

function App() {
  return (
    <div className="card">
      <div className="top">
        <Header />
        <Identity />
      </div>
      <div className="bottom">
        <Biodata />
        <Highlight />
      </div>
    </div>
  );
}

function SocialButton({ icon, link }) {
  return (
    <button onClick={() => window.open(link, "_blank")}>
      <i className={`fab ${icon}`}></i>
    </button>
  );
}

function Header() {
  const middleIndex = Math.floor(socialMedia.length / 2);
  const socialLeft = socialMedia.slice(0, middleIndex);
  const socialRight = socialMedia.slice(middleIndex);

  return (
    <>
      <div className="social-buttons">
        {socialLeft.map((data, index) => (
          <SocialButton icon={data.icon} link={data.href} />
        ))}
      </div>
      <div className="social-buttons right">
        {socialRight.map((data, index) => (
          <SocialButton icon={data.icon} link={data.href} />
        ))}
      </div>
    </>
  );
}

function Identity() {
  return (
    <div className="text">
      <div className="name-wrapper">
        <div className="name">Ling Zephyr Nightblade </div>
      </div>

      <div className="title">Shadow Soaring Engineer</div>
    </div>
  );
}

function Biodata() {
  return (
    <div className="desc">
      <p>
        My name is <b>Ling Zephyr Nightblade</b>, a Shadow Soaring Engineer who
        cuts through code with speed and precision
      </p>
      <p>
        I solve problems quietly and deliver clean, secure results — one line at
        a time.
      </p>
    </div>
  );
}

function Badge({ text }) {
  return (
    <button>
      <div className="height">{text}</div>
    </button>
  );
}

function Highlight() {
  return (
    <div className="buttons">
      <Badge text={`🥷 Ninja`} />
      <Badge text={`⚡Swift`} />
      <Badge text={`🧩 Problem Solver`} />
    </div>
  );
}

const rootElement = document.getElementById("root");
const root = createRoot(rootElement);

root.render(
  <StrictMode>
    <App />
  </StrictMode>
);
